<template>
  <div class="row">
      <div class="col-sm-6 pagination-primary">
        <p class="category">{{ $t('showing') }} {{pagination.from }} {{ $t('to') }} {{pagination.to}} {{ $t('of') }} {{pagination.total}} {{ $t('entries') }}</p>
      </div>
      <div class="col-sm-6">
        <p-pagination class="pull-right" v-model="pagination.currentPage" :per-page="pagination.perPage" :total="pagination.total"></p-pagination>
      </div>
      <div class="col-md-12">
        <custom-pagination :pagination="metadata" :allData="allData"></custom-pagination>
      </div>
  </div>
</template>
<script>
import PPagination from "src/components/UIComponents/Pagination.vue";
import CustomPagination from './CustomPagination.vue';
export default {
  components: { PPagination, CustomPagination },
  props: {
    pagination: {
        type: Object,
        default: () => {
            return {}
        },
        description: 'Pagination variable',
    },
    metadata: {
        type: Object,
        default: () => {
            return {}
        },
        description: 'Pagination variable',
    },
    allData: {
      type: Function,
      default: () => {
          return [{}]
      },
      description: 'Function to reffresh data',
    },
  },
}
</script>
